import axios from "axios";
import { CAMPINA_API, PATOS_API } from "../api/InstanceAPI";

const createInstanceAPI = (unit) => {
  const BASE_URL = unit === "CAMPINA GRANDE" ? CAMPINA_API : PATOS_API;
  return axios.create({
    baseURL: BASE_URL,
  });
};
export const useAPI = () => ({
  validateToken: async (token) => {
    const data = {
      user: {
        id: 5,
        name: "Albert Einstein",
        email: "einstein@colegio.com",
      },
    };
    return data;
  },
  signin: async (login, password, unit) => {
    const api = createInstanceAPI(unit);
    try {
      // Painel web usa login de nível de acesso (/access/login)
      const response = await api.post(`/access/login`, { login, password });
      // A resposta inclui { status, token, user, mustChangePassword }
      return response.data;
    } catch (error) {
      // Tratar 401 de forma amigável para o AuthProvider/FormSignIn
      if (error.response && error.response.status === 401) {
        // Mantém o contrato esperado pelo AuthProvider: objeto sem user truthy
        return { status: false, user: null, message: "Credenciais inválidas" };
      }

      // Para erros não esperados, ainda propagamos para poder debugar,
      // mas evitando quebrar silenciosamente.
      throw error;
    }
  },
  logout: async (unit) => {
    const api = createInstanceAPI(unit);
    const response = await api.post("/users/logout");
    return response.data;
  },
});
